import { useEditor } from "@craftjs/core";
import * as React from "react";

export default function useRichTextCompatible(
  nodeId: string,
  propertyNames: Array<string>
) {
  const { query } = useEditor();

  const isRichTextCompatible = React.useMemo(() => {
    const nodeQuery = query.node(nodeId);
    if (!nodeQuery) {
      return false;
    }

    const linkedNodesTree = nodeQuery.getLinkedNodes().reduce((acc, curr) => {
      acc[curr.id] = curr.node;
      return acc;
    }, {});

    const result = [];
    for (let index = 0; index < propertyNames.length; index++) {
      const propName = propertyNames[index];
      const propId = linkedNodesTree[propName]?.id;

      if (!propId) {
        return true;
      }

      const actualNode = query.node(propId);

      // This will likely never happen, but leaving as a safeguard.
      if (!actualNode) {
        return false;
      }

      // Our plain Text block updates its internal `_text` prop when changed.
      // This is a good indicator for us to know whether or not to render the
      // text within a RichText block or not.
      result.push(!actualNode.props._text && !actualNode.props._text);
    }
    return result.every((item) => Boolean(item));
  }, [nodeId, propertyNames, query]);

  return isRichTextCompatible;
}
